import React from 'react';
import { Download, Printer } from 'lucide-react';
import { fmtMoney, fmtNumber } from '../../format';
import { Chip, Kpi } from '../attendance/shared';

// Missed Days Management: the pieces Stephanet's MissedDays*.jsx screens share (badges, tones, the report table)

export { Chip, Kpi };

// review stages -> badge tone, chart colour, short name
export const STAGES = {
  'Auto Generated': ['auto', '#eab308', 'Auto Generated'],
  'Pending Supervisor Review': ['sent', '#a855f7', 'Pending Supervisor'],
  'Pending HR Review': ['pending', '#f59e0b', 'Pending Review'],
  'Sent to Employee': ['sent', '#8b5cf6', 'Sent to Employee'],
  'Approved - Paid Without Deduction': ['paid', '#16a34a', 'Approved Paid'],
  'Approved - Assigned to Leave': ['leave', '#3b82f6', 'Assigned to Leave'],
  'Declined - Salary Deduction Required': ['deduct', '#dc2626', 'Declined / Deducted'],
  'Biometric Error - Paid': ['bio', '#0d9488', 'Biometric Error'],
  Escalated: ['esc', '#ea580c', 'Escalated'],
  Reversed: ['rev', '#64748b', 'Reversed'],
  'Cancelled - Attendance Corrected': ['cancel', '#94a3b8', 'Cancelled'],
};
export const WARN = { Normal: 'normal', Warning: 'warning', 'HR Query Required': 'query', 'Management Review': 'mgmt' };
export const OPEN = ['Auto Generated', 'Pending Supervisor Review', 'Pending HR Review', 'Sent to Employee', 'Escalated', 'Reversed'];
export const PAY_TONE = { 'Not Required': 'gray', 'Pending Posting': 'yellow', 'Awaiting Posting Approval': 'orange', Posted: 'green', Reversed: 'purple' };
export const STATUS_TONE = {
  'Auto Generated': 'yellow', 'Pending Supervisor Review': 'purple', 'Pending HR Review': 'yellow', 'Sent to Employee': 'purple', 'Approved - Paid Without Deduction': 'green',
  'Approved - Assigned to Leave': 'green', 'Declined - Salary Deduction Required': 'red', 'Biometric Error - Paid': 'teal', Escalated: 'orange',
  Reversed: 'gray', 'Cancelled - Attendance Corrected': 'gray',
};
export const WARN_TONE = { Normal: 'green', Warning: 'yellow', 'HR Query Required': 'red', 'Management Review': 'darkred' };

export function StageBadge({ value }) {
  const [tone] = STAGES[value] || ['cancel'];
  return <span className={`md-badge s-${tone}`}>{value || '—'}</span>;
}
export function WarnBadge({ value }) {
  return <span className={`md-badge w-${WARN[value] || 'normal'}`}>{value || 'Normal'}</span>;
}

export const num = v => (v === null || v === undefined ? '—' : fmtNumber(v));
export const money = v => (v ? fmtMoney(v) : '—');
export const YesNo = ({ v, bad }) => <span className={`mds-yn ${v ? (bad ? 'bad' : 'yes') : 'no'}`}>{v ? 'Yes' : 'No'}</span>;

export const thisMonth = () => new Date().toISOString().slice(0, 7);
export const shiftMonth = (m, n) => { const d = new Date(`${m}-01T00:00:00`); d.setMonth(d.getMonth() + n); return d.toISOString().slice(0, 7); };
export const lastDay = m => { const d = new Date(`${m}-01T00:00:00`); d.setMonth(d.getMonth() + 1); d.setDate(0); return `${m}-${String(d.getDate()).padStart(2, '0')}`; };
const iso = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const yesterday = () => { const d = new Date(); d.setDate(d.getDate() - 1); return iso(d); };

// foot: [label, label colspan, value, trailing colspan]
export function Table({ head, rows, row, foot, note, empty = 'No records for this period.', onExport }) {
  return (
    <div className="mdr-card mdr-table-card">
      <div className="mds-table-head">
        <span className="mds-note-inline">{note || `${rows.length} record(s)`}</span>
        <div className="no-print" style={{ display: 'flex', gap: 8 }}>
          {onExport && <button className="mdr-btn" onClick={onExport} disabled={!rows.length}><Download size={13} /> Export</button>}
          <button className="mdr-btn" onClick={() => window.print()}><Printer size={13} /> Print</button>
        </div>
      </div>
      <div className="mdr-scroll">
        <table className="mdr-table mds-table">
          <thead><tr>{head.map(h => <th key={h}>{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((r, i) => <tr key={r.id || r.reference || i} className="mdr-row" style={{ animationDelay: `${Math.min(i, 20) * 22}ms` }}>{row(r, i).map((c, j) => <td key={j}>{c}</td>)}</tr>)}
            {!rows.length && <tr><td colSpan={head.length} className="mdr-empty">{empty}</td></tr>}
          </tbody>
          {foot && rows.length > 0 && (
            <tfoot><tr><td colSpan={foot[1]}>{foot[0]}</td><td>{foot[2]}</td>{foot[3] > 0 && <td colSpan={foot[3]} />}</tr></tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
